import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { FileMetadata } from 'src/app/models/collection.interface';

export const CollectionDocFetch = createAction('[CollectionDoc] Fetch', props<{ collectionId: string }>());
export const CollectionDocFetched = createAction(
  '[CollectionDoc] Fetched',
  props<{ collectionId: string; collection: FileMetadata[] }>()
);
export const CollectionDocError = createAction('[CollectionDoc] Error', props<{ collectionId: string }>());

export const initialState: Record<string, CommonApiState<FileMetadata[]>> = {};

export const collectionDocFeature = createFeature({
  name: 'collectionDoc',
  reducer: createReducer(
    initialState,
    on(CollectionDocFetch, (state, action) => ({
      ...state,
      [action.collectionId]: {
        ...(state[action.collectionId] ?? {}),
        currentPedingApis: (state[action.collectionId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(CollectionDocFetched, (state, action) => {
      return {
        ...state,
        [action.collectionId]: {
          ...(state[action.collectionId] ?? {}),
          currentPedingApis: 0,
          data: action.collection
        }
      };
    }),
    on(CollectionDocError, (state, action) => {
      return {
        ...state,
        [action.collectionId]: {
          ...(state[action.collectionId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectCollectionDocState }) => {
    const collectionDocIsLoading = (collectionId: string) =>
      createSelector(
        selectCollectionDocState,
        collectionState => (collectionState[collectionId]?.currentPedingApis ?? 0) > 0
      );

    const collectionDocHasPendingRequest = (collectionId: string) =>
      createSelector(
        selectCollectionDocState,
        collectionState => (collectionState[collectionId]?.currentPedingApis ?? 0) >= 2
      );
    const collectionDocData = (collectionId: string) => {
      return createSelector(selectCollectionDocState, collectionDocState => {
        return collectionDocState[collectionId]?.data;
      });
    };

    return { collectionDocIsLoading, collectionDocHasPendingRequest, collectionDocData };
  }
});
